const companies = {
  Amazon:
    "https://cantileverlabs-gradient-images.s3.ap-south-1.amazonaws.com/company+logos/amazon_PNG13.png",
  Facebook:
    "https://cantileverlabs-gradient-images.s3.ap-south-1.amazonaws.com/company+logos/facebook_logo.png",
  TCS: "https://cantileverlabs-gradient-images.s3.ap-south-1.amazonaws.com/company+logos/TCS_LOGO.png",
  Wipro:
    "https://cantileverlabs-gradient-images.s3.ap-south-1.amazonaws.com/company+logos/IMG-20220923-WA0006.jpg",
  Microsoft:
    "https://cantileverlabs-gradient-images.s3.ap-south-1.amazonaws.com/company+logos/IMG-20220923-WA0003.jpg",
  Google:
    "https://cantileverlabs-gradient-images.s3.ap-south-1.amazonaws.com/company+logos/IMG-20220923-WA0007.jpg",
};

function CompaniesCards(props) {
  const { name, category, level, link, company } = props;
  function getDifficultyStatus(level) {
    if (level <= 2) {
      return "Easy";
    } else if (level === 3) {
      return "Medium";
    } else {
      return "Hard";
    }
  }
  return (
    <a
      className="col-md-4 col-sm-6 mb-md-4 mb-2"
      href={link}
      target="_blank"
      rel="noreferrer"
    >
      <div className="diffcultyCard">
        <div className="diffcultyCardHead">
          <div className="diffcultyCodingName">{name}</div>
          <div className="diffcultyResult"></div>
        </div>
        <hr />
        <div className="diffcultyCardFoot">
          <div className="diffcultyBtn" style={{ background: "#D9EAB3" }}>
            {getDifficultyStatus(level)}
          </div>
          <div
            className="diffcultyBtn"
            style={{
              background: "#494343",
              padding: "0px 25px",
              width: "100px",
              overflow: "hidden",
              textAlign: "center",
            }}
          >
            {category}
          </div>
        </div>
        <div className="diffcultyCardBody">
          <ul className="diffcultyType">
            {company.map((val, index) => {
              return (
                <li
                  key={index}
                  className="diffcultyTypeItem"
                >
                  <img
                    className=" mt-1"
                    src={val.logo}
                    alt={`${val.name} logo`}
                    height={30}
                    width={30}
                    style={{
                      objectFit: "contain",
                    }}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </a>
  );
}

export default CompaniesCards;
